<template>
  <div :class="$style.icon" />
</template>

<script type="text/ecmascript-6">
export default {
  name: 'NewIcon'
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  border-radius: 50%;
  border: 1px solid map-get($colors, 'new-blue');
}
</style>
